import { ConfigRepository } from 'root/lsCloud/EntityRepository/ConfigRepository';
import { OptionRepository } from 'root/lsCloud/EntityRepository/OptionRepository';
import { ShopRepository } from 'root/lsCloud/EntityRepository/ShopRepository';
import { UserPreferenceRepository } from 'root/lsCloud/EntityRepository/UserPreferenceRepository';

window.lsCloud = {
  getJSONFromAPI(path) {
    const deferred = $.Deferred();
    // readonly forces the connection to be made against the slave databases
    $.getJSON(path, { readonly: '1' })
      .done((data) => deferred.resolve(data))
      .fail((jqXHR, textStatus, errorThrown) => {
        deferred.reject(jqXHR, textStatus, errorThrown);
      });
    return deferred.promise();
  },

  startServerJob(job, silent_fail) {
    const deferred = $.Deferred();
    const json = JSON.stringify(job.obj);
    const type = 'PUT';

    const obj: LSCloudServerJob = {
      type,
      url: job.url,
      data: job.data,
    };

    if (job.type) {
      obj.type = job.type;
    }

    // Handle json data differently than xml data
    if (json) {
      obj.data = json;
      obj.contentType = 'application/json; charset=utf-8';
      obj.dataType = 'json';
    }

    $.ajax(obj)
      .done((data, _textStatus, jqXHR) => {
        deferred.resolve(data);
        return jqXHR;
      })
      .fail((jqXHR, _textStatus, errorThrown) => {
        window.merchantos.error(jqXHR, errorThrown);

        if (silent_fail) {
          deferred.resolve(errorThrown);
          return;
        }
        const e = jqXHR;
        if (e.status !== 401) {
          let errorMessage = 'Please Try Again';
          try {
            errorMessage = [
              'PanException',
              'DuplicatedVendorNumsException',
              'DuplicatedEanException',
              'ItemAttributesException',
              'InvalidVendorNumException',
            ].includes(e.responseJSON?.errorClass)
              ? e.responseJSON?.message
              : errorMessage;

            errorMessage = JSON.parse(e.responseText).failed_msg || errorMessage;
            // eslint-disable-next-line no-empty
          } catch (error) {}

          if (window.alertUser) window.alertUser(`Couldn't save (${errorMessage})`);
          deferred.reject(e);
          return;
        }
        deferred.reject(e);
      });

    return deferred;
  },

  Config: new ConfigRepository(),

  Modules: {
    waitForModules: $.Deferred(),
    /** Module cache */
    __modules: {},

    /**
     * Stores all customer modules.
     * @param {Object} modules
     */
    setModules(modules) {
      if (typeof modules !== 'object') {
        window.merchantos.error('Tried to use non-object for Modules.');
      } else {
        const module_cache = this.__modules;
        // Delete old module entries
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        Object.keys(module_cache).forEach((key) => delete module_cache[key]);
        // Set new modules
        Object.keys(modules).forEach((key) => {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          module_cache[key] = modules[key];
        });
        this.waitForModules.resolve();
      }
    },

    /**
     * Returns true or false if the account has this module or not.
     * @param {String} module_name
     * @returns {boolean}
     */
    hasModule(module_name) {
      return !!this.__modules[module_name];
    },
  },

  Options: new OptionRepository(),

  UserPreferences: new UserPreferenceRepository(),

  Shops: new ShopRepository(),

  analytics: {
    record() {
      // Google Analytics
      if (typeof window.ga !== 'undefined') {
        window.ga('send', 'pageview');
      }
    },
  },
};
